(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-upsell"] && !Shopify.designMode) return;
  try {
    class CartUpsell extends HTMLElement {
    connectedCallback() {
      let productId = this.dataset.productId;
      if (!productId) return;

      fetch('/recommendations/products.json?product_id=' + productId + '&intent=complementary&limit=2')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!data.products || !data.products.length) return;
          this.render(data.products);
        }.bind(this))
        .catch(function () {});
    }

    render(products) {
      let moneyFormat = document.body.dataset.moneyFormat || '$\{\{amount\}\}';
      let grid = this.querySelector('.cart-upsell__grid');
      if (!grid) return;

      grid.innerHTML = products.map(function (p) {
        let price = formatMoney(p.price, moneyFormat);
        let img = p.featured_image
          ? '<img src="' + p.featured_image + '" alt="' + escHtml(p.title) + '" loading="lazy" class="cart-upsell-card__img" width="80" height="80">'
          : '';
        return '<div class="cart-upsell-card" data-product-id="' + p.id + '">'
          + '<div class="cart-upsell-card__img-wrap">' + img + '</div>'
          + '<div class="cart-upsell-card__info">'
          + '<span class="cart-upsell-card__title">' + escHtml(p.title) + '</span>'
          + '<span class="cart-upsell-card__price">' + price + '</span>'
          + '<button class="cart-upsell-card__add" data-variant-id="' + p.variants[0].id + '" aria-label="Add ' + escHtml(p.title) + ' to cart">'
          + (document.body.dataset.upsellAdd || 'Add') + '</button>'
          + '</div>'
          + '</div>';
      }).join('');

      this.hidden = false;

      grid.addEventListener('click', this.onAdd.bind(this));
    }

    onAdd(e) {
      let btn = e.target.closest('.cart-upsell-card__add');
      if (!btn) return;
      let variantId = btn.dataset.variantId;
      if (!variantId || btn.dataset.loading !== undefined) return;

      btn.dataset.loading = '';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
        .then(function () {
          delete btn.dataset.loading;
          btn.dataset.added = '';
          btn.textContent = document.body.dataset.upsellAdded || '✓';
          document.dispatchEvent(new CustomEvent('cart:updated'));
          setTimeout(function () {
            delete btn.dataset.added;
            btn.textContent = document.body.dataset.upsellAdd || 'Add';
          }, 2000);
        })
        .catch(function () { delete btn.dataset.loading; });
    }
  }

  function formatMoney(cents, format) {
    let fmt = format || '$\{\{amount\}\}';
    return fmt.replace('\{\{amount\}\}', (cents / 100).toFixed(2));
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  if (!customElements.get('cart-upsell')) {
    customElements.define('cart-upsell', CartUpsell);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["currency-selector"] && !Shopify.designMode) return;
  try {
    (function () {
    function initCurrencySelector(btn) {
      let listId = btn.getAttribute('aria-controls');
      let list = document.getElementById(listId);
      if (!list) return;

      function open() {
        list.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
        let first = list.querySelector('.locale-sel__option');
        if (first) first.focus();
      }

      function close() {
        list.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        btn.focus();
      }

      btn.addEventListener('click', function () {
        let expanded = btn.getAttribute('aria-expanded') === 'true';
        expanded ? close() : open();
      });

      btn.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); open(); }
        if (e.key === 'Escape') close();
      });

      list.addEventListener('keydown', function (e) {
        let options = Array.from(list.querySelectorAll('.locale-sel__option'));
        let idx = options.indexOf(document.activeElement);
        if (e.key === 'ArrowDown') { e.preventDefault(); options[(idx + 1) % options.length].focus(); }
        if (e.key === 'ArrowUp')   { e.preventDefault(); options[(idx - 1 + options.length) % options.length].focus(); }
        if (e.key === 'Escape')    { e.preventDefault(); close(); }
        if (e.key === 'Tab')       close();
      });

      document.addEventListener('click', function (e) {
        if (!btn.closest('.currency-sel').contains(e.target)) {
          list.hidden = true;
          btn.setAttribute('aria-expanded', 'false');
        }
      });
    }

    document.querySelectorAll('.currency-sel__btn').forEach(initCurrencySelector);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gift-wrap"] && !Shopify.designMode) return;
  try {
    (function () {
    let wraps = document.querySelectorAll('[data-gift-wrap]');
    wraps.forEach(function (wrap) {
      let checkbox = wrap.querySelector('[data-gift-wrap-checkbox]');
      let messageWrap = wrap.querySelector('[data-gift-wrap-message-wrap]');
      let messageInput = wrap.querySelector('[data-gift-wrap-message]');
      let charsEl = wrap.querySelector('[data-gift-wrap-remaining]');
      let maxLen = messageInput ? parseInt(messageInput.getAttribute('maxlength'), 10) || 280 : 280;

      if (checkbox && messageWrap) {
        checkbox.addEventListener('change', function () {
          messageWrap.hidden = !checkbox.checked;
          checkbox.setAttribute('aria-expanded', String(checkbox.checked));
          if (checkbox.checked && messageInput) { messageInput.focus(); }
        });
      }

      if (messageInput && charsEl) {
        messageInput.addEventListener('input', function () {
          charsEl.textContent = String(maxLen - messageInput.value.length);
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["language-selector"] && !Shopify.designMode) return;
  try {
    (function () {
    function initSelector(btn) {
      let listId = btn.getAttribute('aria-controls');
      let list = document.getElementById(listId);
      if (!list) return;

      function open() {
        list.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
        let first = list.querySelector('.locale-sel__option');
        if (first) first.focus();
      }

      function close() {
        list.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        btn.focus();
      }

      btn.addEventListener('click', function () {
        let expanded = btn.getAttribute('aria-expanded') === 'true';
        expanded ? close() : open();
      });

      btn.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); open(); }
        if (e.key === 'Escape') close();
      });

      list.addEventListener('keydown', function (e) {
        let options = Array.from(list.querySelectorAll('.locale-sel__option'));
        let idx = options.indexOf(document.activeElement);
        if (e.key === 'ArrowDown') { e.preventDefault(); options[(idx + 1) % options.length].focus(); }
        if (e.key === 'ArrowUp')   { e.preventDefault(); options[(idx - 1 + options.length) % options.length].focus(); }
        if (e.key === 'Escape')    { e.preventDefault(); close(); }
        if (e.key === 'Tab')       close();
      });

      document.addEventListener('click', function (e) {
        if (!btn.closest('.locale-sel').contains(e.target)) {
          list.hidden = true;
          btn.setAttribute('aria-expanded', 'false');
        }
      });
    }

    document.querySelectorAll('.locale-sel__btn').forEach(initSelector);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["popular-upgrades"] && !Shopify.designMode) return;
  try {
    (function () {
    let panels = document.querySelectorAll('[data-popular-upgrades]');
    panels.forEach(function (panel) {
      let basePrice = parseInt(panel.dataset.basePrice, 10) || 0;
      let checkboxes = Array.from(panel.querySelectorAll('.popular-upgrades__checkbox'));
      let footer = panel.querySelector('[data-upgrades-footer]');
      let subtotalEl = panel.querySelector('[data-upgrades-subtotal]');
      let addBtn = panel.querySelector('[data-upgrades-add-btn]');
      let btnText = panel.querySelector('[data-upgrades-btn-text]');
      let btnLoading = panel.querySelector('[data-upgrades-btn-loading]');

      function formatMoney(cents) {
        let symbol = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ? '' : '';
        return (window.__currency || '') + (cents / 100).toFixed(2);
      }

      function updateUI() {
        let selectedCount = checkboxes.filter(function (cb) { return cb.checked; }).length;
        let extra = checkboxes.reduce(function (sum, cb) {
          return cb.checked ? sum + parseInt(cb.dataset.upgradePrice, 10) : sum;
        }, 0);

        if (subtotalEl) {
          let total = basePrice + extra;
          subtotalEl.textContent = (total / 100).toFixed(2).replace('.', window.Shopify && window.Shopify.money_format && window.Shopify.money_format.includes(',') ? ',' : '.') + ' ' + (window.__currency || '');
        }

        if (footer) { footer.hidden = selectedCount === 0; }
      }

      checkboxes.forEach(function (cb) {
        cb.addEventListener('change', updateUI);
      });

      if (addBtn) {
        addBtn.addEventListener('click', function () {
          let selected = checkboxes.filter(function (cb) { return cb.checked && !cb.disabled; });
          if (!selected.length) return;

          addBtn.disabled = true;
          if (btnText)    btnText.hidden    = true;
          if (btnLoading) btnLoading.hidden = false;

          let items = selected.map(function (cb) {
            return { id: parseInt(cb.value, 10), quantity: 1 };
          });

          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
            selected.forEach(function (cb) { cb.checked = false; });
            updateUI();
          })
          .catch(function (err) { console.warn('Upgrade add failed', err); })
          .finally(function () {
            addBtn.disabled = false;
            if (btnText)    btnText.hidden    = false;
            if (btnLoading) btnLoading.hidden = true;
          });
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function() {
    if (document.documentElement.dataset.cardQaInit) return;
    document.documentElement.dataset.cardQaInit = '1';

    document.addEventListener('click', async function(e) {
      let btn = e.target.closest('.card__quick-add-btn[data-variant-id]');
      if (!btn || btn.dataset.loading) return;

      let variantId = parseInt(btn.dataset.variantId, 10);
      if (!variantId) return;

      btn.dataset.loading = 'true';
      btn.disabled = true;
      let origText = btn.textContent.trim();
      btn.textContent = '…';

      try {
        let resp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
        if (!resp.ok) {
          let errData = await resp.json().catch(function() { return {}; });
          throw new Error(errData.description || 'Failed');
        }
        btn.textContent = btn.dataset.textAdded;
        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('cart:open'));
        await new Promise(function(r) { setTimeout(r, 1400); });
        btn.textContent = origText;
      } catch (err) {
        let errorLabel = btn.dataset.textError || '✕ Error';
        btn.textContent = errorLabel;
        btn.dataset.error = 'true';
        setTimeout(function() {
          btn.textContent = origText;
          delete btn.dataset.error;
        }, 3000);
      } finally {
        btn.disabled = false;
        delete btn.dataset.loading;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-guide"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('.size-guide__trigger').forEach(function (btn) {
      let dialogId = btn.getAttribute('aria-controls');
      let dialog = document.getElementById(dialogId);
      if (!dialog) return;

      let closeBtn = dialog.querySelector('.size-guide__close');

      btn.addEventListener('click', function () {
        dialog.showModal();
        btn.setAttribute('aria-expanded', 'true');
      });

      function close() {
        dialog.close();
        btn.setAttribute('aria-expanded', 'false');
        btn.focus();
      }

      closeBtn && closeBtn.addEventListener('click', close);
      dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });
      dialog.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.preventDefault(); close(); } });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
